import { observable, action } from 'mobx';
import { db } from '../firebase';
import history from '../components/history';
import * as toastr from 'toastr';
import { v4 as uuidv4 } from 'uuid';

// =====================================
// CONSTS
import { Messages } from '../const/Messages';

// =====================================
// STORES
import { commonStore } from './CommonStore';

// =====================================
// MODELS
import { Article } from '../models/Article';
import { User } from '../models/User';

export interface IArticleStore {
    articles: Array<Article>;
    favorites: Array<Article>;
    helperArticles: Array<Article>;
    keyword: string;
    selectedRowId: string;
    //lastVisible: any;

    isLoading: boolean;
    isSearchEmpty: boolean;
    isSearchHeaderVisible: boolean;
    isArticleListVisible: boolean;
    isModalVisible: boolean;
    //hasMoreArticlesToLoad: boolean;

    init(): void;
    //fetchMoreArticles(): void;
    showSearchHeader(): void;
    hideSearchHeader(): void;
    handleArticleSearch(event: any);
    clearArticleSearch(): void;
    addToFavorites(article: Article): void;
    goToArticleDetails(): void;
    goBackToAricles(): void;
    showInputForPriceChange(article: Article): void;
    handleChangeAcquisitionPrice(event: any, id: any): void;
    handleShowModal(): void;
    handleCloseModal(): void;
    saveFavorite(customerId: string, orderId: string): void;
    reset(): void;
}

export class ArticleStore implements IArticleStore {
    constructor() {
        this.articles = [];
        this.favorites = [];
        this.helperArticles = [];
        this.keyword = "";
        this.selectedRowId = "";
        //this.lastVisible = null;

        this.isLoading = true;
        this.isSearchEmpty = false;
        this.isSearchHeaderVisible = false;
        this.isArticleListVisible = false;
        this.isModalVisible = false;
        //this.hasMoreArticlesToLoad = true;
    }

    @observable articles: Array<Article>;
    @observable favorites: Array<Article>;
    @observable helperArticles: Array<Article>;
    @observable keyword: string;
    @observable selectedRowId: string;
    //@observable lastVisible: any;

    @observable isLoading: boolean;
    @observable isSearchEmpty: boolean;
    @observable isSearchHeaderVisible: boolean;
    @observable isArticleListVisible: boolean;
    @observable isModalVisible: boolean;
    //@observable hasMoreArticlesToLoad: boolean;

    @action init = (): void => {
        this.getArticles();
    }

    @action getArticles = async () => {
        try {
            let currentUser: User = commonStore.user;

            const doc = await db.collection('catalogs')
                .doc(currentUser.orgId)
                .collection('articles')
                .where('isInactive', '==', false)
                .get();

            if (!doc.empty) {
                //this.lastVisible = doc.docs[doc.docs.length - 1];
                doc.forEach((doc) => {
                    let article: Article = new Article();
                    article.VAT = doc.data().VAT;
                    article.acquisitionPrice = doc.data().acquisitionPrice;
                    article.code = doc.data().code;
                    article.id = doc.data().id;
                    article.name = doc.data().name;
                    article.unitOfMeasurement = doc.data().unitOfMeasurement;

                    this.articles.push(article);
                });
            }

            //All favourite articles
            if (localStorage.favoriteArticles !== undefined) {
                var favoriteArticles = JSON.parse(localStorage.favoriteArticles);
                if (favoriteArticles.length > 0) {
                    favoriteArticles.forEach((article: Article) => {
                        let favoriteArticle: Article = new Article();
                        favoriteArticle.VAT = article.VAT;
                        favoriteArticle.acquisitionPrice = article.acquisitionPrice;
                        favoriteArticle.code = article.code;
                        favoriteArticle.id = article.id;
                        favoriteArticle.name = article.name;
                        favoriteArticle.unitOfMeasurement = article.unitOfMeasurement;
                        favoriteArticle.customSalesPrice = article.customSalesPrice !== "" ? article.customSalesPrice.toString() : "";
                        favoriteArticle.copyCustomSalesPrice = article.customSalesPrice !== "" ? article.customSalesPrice.toString() : "";
                        favoriteArticle.productMaxOrderQuantity = article.productMaxOrderQuantity;
                        favoriteArticle.productMinOrderQuantity = article.productMinOrderQuantity;
                        //favoriteArticle.productTransportPackageSize = article.productTransportPackageSize;
                        favoriteArticle.stepDown = article.stepDown;
                        favoriteArticle.stepUp = article.stepUp;

                        this.favorites.push(favoriteArticle);
                    });
                }
            }

            this.isLoading = false;
        }
        catch (error) {
            this.isLoading = false;
            console.error("Error getting articles: ", error);
        };
    }

    // @action fetchMoreArticles = async () => {
    //     try {
    //         let currentUser: User = commonStore.user;

    //         const doc = await db.collection('catalogs')
    //             .doc(currentUser.orgId)
    //             .collection('articles')
    //             .startAfter(this.lastVisible)
    //             .limit(15)
    //             .get();

    //         if (!doc.empty) {
    //             this.lastVisible = doc.docs[doc.docs.length - 1];
    //             this.hasMoreArticlesToLoad = true;
    //             doc.forEach((doc) => {
    //                 let article: Article = new Article();
    //                 article.VAT = doc.data().VAT;
    //                 article.acquisitionPrice = doc.data().acquisitionPrice;
    //                 article.code = doc.data().code;
    //                 article.id = doc.data().id;
    //                 article.name = doc.data().name;
    //                 article.unitOfMeasurement = doc.data().unitOfMeasurement;

    //                 this.articles.push(article);
    //             });
    //         } else {
    //             this.hasMoreArticlesToLoad = false;
    //         }

    //         this.isLoading = false;
    //     }
    //     catch (error) {
    //         this.isLoading = false;
    //         console.error("Error getting articles: ", error);
    //     };
    // }

    @action showSearchHeader = (): void => {
        this.isSearchHeaderVisible = true;
        this.helperArticles = this.articles;
        this.articles = [];
    }

    @action hideSearchHeader = (): void => {
        this.keyword = "";
        this.isSearchHeaderVisible = false;
        this.isSearchEmpty = false;
        this.articles = this.helperArticles;
    }

    @action handleArticleSearch = async (event: any) => {
        this.keyword = event.target.value;
        this.isLoading = true;

        //let articlesHelper: Array<Article> = [];
        //let currentUser: User = commonStore.user;
        // let articlesRef = db.collection('catalogs')
        //     .doc(currentUser.orgId)
        //     .collection('articles');

        //if (this.keyword.length >= 3) {
        // const result = await articlesRef
        //     .where('code', '>=', this.keyword)
        //     .where('code', '<=', this.keyword + '\uf8ff')
        //     .get();

        let articlesHelper: Array<Article> = this.helperArticles.filter(item => {
            return item.code.toLowerCase().includes(this.keyword.toLowerCase()) ||
                item.name.toLowerCase().includes(this.keyword.toLowerCase());
        });

        // if (!result.empty) {
        //     result.forEach((doc) => {
        //         articlesHelper = [...articlesHelper, doc.data() as any];
        //     });
        //     this.isSearchEmpty = false;
        // } else {
        //     this.isSearchEmpty = true;
        // }
        //}

        //if (this.keyword.length >= 5) {
        // const result = await articlesRef
        //     .where('name', '>=', this.keyword)
        //     .where('name', '<=', this.keyword + '\uf8ff')
        //     .get();

        //articlesHelper = this.helperArticles

        // if (!result.empty) {
        //     result.forEach((doc) => {
        //         articlesHelper = [...articlesHelper, doc.data() as any];
        //     });
        //     this.isSearchEmpty = false;
        // } else {
        //     this.isSearchEmpty = true;
        // }
        //}

        if (articlesHelper.length > 0) {
            this.isSearchEmpty = false;
        } else {
            this.isSearchEmpty = true;
        }

        this.articles = [...articlesHelper];
        this.isLoading = false;
    }

    @action clearArticleSearch = (): void => {
        this.keyword = "";
        this.isSearchEmpty = false;
        this.articles = [];
    }

    @action addToFavorites = (article: Article): void => {
        let addArray: boolean = true;
        this.favorites.map((item, key) => {
            if (item.id === article.id) {
                this.favorites.splice(key, 1);
                addArray = false;
            }
        });
        if (addArray) {
            this.favorites.push(article);
        }
    }

    @action goToArticleDetails = () => {
        if (this.favorites.length > 0) {
            this.isArticleListVisible = true;
        } else {
            toastr.error(Messages.NO_ARTICLES_ADDED_FOR_CUSTOMER);
        }
    }

    @action goBackToAricles = () => {
        this.isArticleListVisible = false;
        this.isModalVisible = false;
        this.selectedRowId = "";

        this.favorites.forEach((item) => {
            item.customSalesPrice = item.copyCustomSalesPrice;
        });
    }

    @action showInputForPriceChange = (article: Article) => {
        this.selectedRowId = article.id;
    }

    @action handleChangeAcquisitionPrice = (event: any, id: any): void => {
        const { value } = event.target;
        let curentArticle = this.favorites.filter(article => article.id === id)[0];
        curentArticle.customSalesPrice = value;
    }

    @action handleShowModal = () => {
        let changedFavoriteArticles = this.favorites.filter(article => article.customSalesPrice !== article.copyCustomSalesPrice);
        if (changedFavoriteArticles.length > 0) {
            this.isModalVisible = true;
        } else {
            this.goBackToAricles();
        }
    }

    @action handleCloseModal = () => {
        this.isModalVisible = false;
    }

    @action saveFavorite = async (customerId: string, orderId: string) => {
        try {
            let currentUser: User = commonStore.user;
            let id: string = uuidv4();

            const docFavouriteAarticles = await db.collection("organizations")
                .doc(currentUser.orgId)
                .collection('customers')
                .doc(customerId)
                .collection('favourite_articles')
                .get();

            let favouriteArticleDocumentId: string = "";
            docFavouriteAarticles.forEach(async (doc) => {
                favouriteArticleDocumentId = doc.data().id;
            });

            if (favouriteArticleDocumentId !== "") {
                await db.collection("organizations")
                    .doc(currentUser.orgId)
                    .collection("customers")
                    .doc(customerId)
                    .collection("favourite_articles")
                    .doc(favouriteArticleDocumentId)
                    .delete();
            }

            let articles = [];
            this.favorites.forEach((item) => {
                let article = {
                    id: item.id,
                    customSalesPrice: item.customSalesPrice !== "" ? +item.customSalesPrice : 0,
                    code: item.code !== "" ? item.code : 9999,
                    productMaxOrderQuantity: item.productMaxOrderQuantity !== 0 ? item.productMaxOrderQuantity : 999999,
                    productMinOrderQuantity: item.productMinOrderQuantity !== 0 ? item.productMinOrderQuantity : 0,
                    //productTransportPackageSize: item.productTransportPackageSize !== 0 ? item.productTransportPackageSize : 1,
                    stepDown: item.stepDown !== 0 ? item.stepDown : 1,
                    stepUp: item.stepUp !== 0 ? item.stepUp : 5
                };

                articles.push(article);
            });

            await db.collection("organizations")
                .doc(currentUser.orgId)
                .collection("customers")
                .doc(customerId)
                .collection("favourite_articles")
                .doc(id)
                .set({
                    id: id,
                    articles: articles
                });

            toastr.success(Messages.CHANGES_SAVED);

            if (orderId !== undefined) {
                history.push(`/editorder/${customerId}/${orderId}`);
            } else {
                history.push(`/neworder/${customerId}`);
            }
        }
        catch (error) {
            console.error("Error saving document: ", error);
        };
    }

    @action reset = (): void => {
        this.articles = [];
        this.favorites = [];
        this.helperArticles = [];
        this.keyword = "";
        this.selectedRowId = "";
        //this.lastVisible = null;

        this.isLoading = true;
        this.isSearchEmpty = false;
        this.isSearchHeaderVisible = false;
        this.isArticleListVisible = false;
        this.isModalVisible = false;
        //this.hasMoreArticlesToLoad = true;
    }
}

export let articleStore = new ArticleStore();